import React, { useState } from 'react';

// 더미 데이터
const dummyClasses = [
    {
        id: 1,
        title: '기초 연기 클래스',
        description: '연기 초보자를 위한 기초 클래스입니다.',
        studentCount: 15,
        maxStudents: 20,
        schedule: '매주 월요일, 수요일 19:00-21:00',
        status: '진행중',
        price: 100000,
        enrolledStudents: [
            { id: 1, name: '김지망', image: 'https://via.placeholder.com/40' },
            { id: 2, name: '박연습', image: 'https://via.placeholder.com/40' },
            { id: 3, name: '이성장', image: 'https://via.placeholder.com/40' }
        ]
    },
    {
        id: 2,
        title: '고급 댄스 클래스',
        description: '힙합과 K-pop 댄스를 배우는 고급 클래스입니다.',
        studentCount: 8,
        maxStudents: 10,
        schedule: '매주 화요일, 목요일 18:00-20:00',
        status: '진행중',
        price: 150000,
        enrolledStudents: [
            { id: 4, name: '최댄스', image: 'https://via.placeholder.com/40' },
            { id: 5, name: '정춤춤', image: 'https://via.placeholder.com/40' }
        ]
    },
    {
        id: 3,
        title: '보컬 트레이닝',
        description: '개인 맞춤형 보컬 레슨입니다.',
        studentCount: 5,
        maxStudents: 8,
        schedule: '매주 금요일 17:00-19:00',
        status: '모집중',
        price: 120000,
        enrolledStudents: [
            { id: 6, name: '강노래', image: 'https://via.placeholder.com/40' }
        ]
    }
];

const KoachCoachingClass = () => {
    const [classes] = useState(dummyClasses);

    return (
        <div className="min-h-screen bg-gray-50 pt-20 pb-4 px-4">
            <div className="max-w-6xl mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">클래스</h1>
                    <button className="px-4 py-2 bg-[#CF3688] text-white rounded-lg hover:bg-[#B52E74] transition-colors">
                        새 클래스 만들기
                    </button>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {classes.map((classItem) => (
                        <div key={classItem.id} className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow">
                            <div className="flex justify-between items-start mb-4">
                                <h3 className="text-lg font-semibold text-gray-900">{classItem.title}</h3>
                                <span className={`px-2 py-1 rounded-full text-xs ${
                                    classItem.status === '진행중' 
                                        ? 'bg-green-100 text-green-700' 
                                        : 'bg-blue-100 text-blue-700'
                                }`}>
                                    {classItem.status}
                                </span>
                            </div>
                            
                            <p className="text-gray-600 text-sm mb-4">{classItem.description}</p>
                            
                            <div className="space-y-2 mb-4">
                                <div className="flex items-center text-sm text-gray-600">
                                    <span className="font-medium mr-2">인원:</span>
                                    <span>{classItem.studentCount} / {classItem.maxStudents}명</span>
                                </div>
                                <div className="flex items-center text-sm text-gray-600">
                                    <span className="font-medium mr-2">일정:</span>
                                    <span>{classItem.schedule}</span>
                                </div>
                                <div className="flex items-center text-sm text-gray-600">
                                    <span className="font-medium mr-2">가격:</span>
                                    <span className="text-[#CF3688] font-semibold">{classItem.price.toLocaleString()}원</span>
                                </div>
                            </div>
                            
                            <div className="mb-4">
                                <p className="text-sm font-medium text-gray-700 mb-2">수강생</p>
                                <div className="flex -space-x-2">
                                    {classItem.enrolledStudents.map((student) => (
                                        <img 
                                            key={student.id}
                                            src={student.image} 
                                            alt={student.name}
                                            className="w-8 h-8 rounded-full border-2 border-white object-cover"
                                            title={student.name}
                                        />
                                    ))}
                                    {classItem.studentCount < classItem.maxStudents && (
                                        <div className="w-8 h-8 rounded-full border-2 border-gray-300 border-dashed flex items-center justify-center bg-gray-100">
                                            <span className="text-xs text-gray-400">+</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className="flex gap-2">
                                <button className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm">
                                    상세보기
                                </button>
                                <button className="flex-1 px-4 py-2 bg-[#CF3688] text-white rounded-lg hover:bg-[#B52E74] transition-colors text-sm">
                                    관리
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KoachCoachingClass;

